import React from 'react';
import Modal from 'modules/common/components/Modal';
import fetch from 'utils/fetch';
import Dropdown from 'modules/common/components/Dropdown';
import cx from 'classnames';

const renderDefault = () => (
  <div className="default text">Modèle de document</div>
);

const renderModel = document => (
  <div key={document.id} data-value={document.id} className="item">
    {document.label}
  </div>
);

export default class ChooseModelModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
      items: [],
      selected: undefined,
    };
  }

  componentDidMount() {
    // Loading models
    this.setState({
      isFetching: true,
    });

    fetch('/pco-manager/settings/documents.json')
      .then(res => res.json())
      .then(items => {
        this.setState({ items, isFetching: false });
      });
  }

  onOpen = () =>
    this.setState({
      selected: undefined,
    });

  onConfirm = () => {
    const { selected } = this.state;
    if (selected != null) {
      this.props.onConfirm(selected);
    }
  };

  onChange = id => {
    this.setState(state => ({
      selected: state.items.find(i => i.id.toString() === id.toString()),
    }));
  };

  renderContent() {
    const { isFetching, items } = this.state;

    if (!isFetching && items.length === 0) {
      return (
        <div className="ui info message">
          Aucun modèle de document configuré
        </div>
      );
    } else {
      return (
        <div className="ui field">
          <label>Choisissez un modèle de document</label>
          <Dropdown
            items={items}
            loading={isFetching}
            onChange={this.onChange}
            renderDefault={renderDefault}
            renderItem={renderModel}
          />
        </div>
      );
    }
  }

  render() {
    const { isOpened } = this.props;
    const { selected } = this.state;

    const buttonClassName = cx('ui approve primary button icon labeled', {
      disabled: selected == null,
    });

    return (
      <Modal
        isOpened={isOpened}
        onOpen={this.onOpen}
        onClose={this.props.onClose}
        closable
      >
        <div className="header">Modèle de document</div>
        <div className="content ui form">{this.renderContent()}</div>
        <div className="actions">
          <button className={buttonClassName} onClick={this.onConfirm}>
            <i className="icon check" />Sélectionner
          </button>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/ChooseModelModal.js